module.exports = __webpack_public_path__ + "img/v4_assetsBalance_h.6069c358.png";